import { render, staticRenderFns } from "./templateDialog.vue?vue&type=template&id=c1c251fe&scoped=true"
import script from "./templateDialog.vue?vue&type=script&lang=ts"
export * from "./templateDialog.vue?vue&type=script&lang=ts"
import style0 from "./templateDialog.vue?vue&type=style&index=0&id=c1c251fe&prod&lang=scss&scoped=true"
import style1 from "./templateDialog.vue?vue&type=style&index=1&id=c1c251fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c251fe",
  null
  
)

export default component.exports